export default __webpack_public_path__ + "static/media/lv.cfcb2922.svg";